module.exports = __webpack_public_path__ + "static/media/Graph_API Table.dae15f98.svg";